<template>
  <v-btn
    class="text-none"
    variant="outlined"
    color="#185C37"
    :style="buttonStyle"
    @click="$emit('click', $event)"
    :title="tooltip"
  >
    <v-img src="/src/assets/images/excel-icon.svg" width="16" height="16" />
    <span class="ml-1" style="font-weight: 700">{{ label }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'ExportButton',
  props: {
    small: { type: Boolean, default: true },
    label: { type: String, default: 'Export' },
    tooltip: { type: String, default: 'Export to CSV' },
  },
  emits: ['click'],
  computed: {
    buttonStyle() {
      const height = this.small ? '32px' : '48px';
      return `border-radius: 14px; height: ${height}; font-size: 13px; background-color: #185c3715`;
    },
  },
};
</script>
